import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import {
  IonDatetime,
  IonDatetimeButton,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRefresher,
  IonRefresherContent,
  useIonViewDidLeave,
  useIonViewWillEnter,
} from "@ionic/react";
import LessonCard from "./LessonCard";
import useAPI from "../../../../hooks/basic/useAPI";

const fromDateDefault = new Date();
fromDateDefault.setDate(1);
// create a variable toDate that contains the first day of the next month
const toDateDefault = new Date(fromDateDefault);
toDateDefault.setMonth(toDateDefault.getMonth() + 1);

function UserLessonsContent({
  userId,
  defaultFilterValue = "Non Pagati",
}) {
  const [fromDate, setFromDate] = useState(fromDateDefault);
  const [toDate, setToDate] = useState(toDateDefault);
  const [showFromDateModal, setShowFromDateModal] = useState(false);
  const [showToDateModal, setShowToDateModal] = useState(false);
  const [lessonsToRecover, setLessonsToRecover] = useState(undefined);

  useIonViewWillEnter(() => {
    if (!userId) return;
    loadData();
  });

  useIonViewDidLeave(() => {
    setLessonsToRecover(undefined);
    setComposedData([]);
  });

  const { callAPI } = useAPI();

  const handleRefresh = (e) => {
    loadData();
    e.detail.complete();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [athletesDictionary, setAthletesDictionary] = useState({});
  const [selectedFilterValue, setSelectedFilterValue] =
    useState(defaultFilterValue);
  const [composedData, setComposedData] = useState([]);

  const filteredData = composedData?.filter((subscription) => {
    return true;
  });

  const checkAllLessonsToRecover = async () => {
    const data = await callAPI({
      url: "/check-all-lessons-to-recover",
      params: { userId },
    });
    setLessonsToRecover(data);
  };

  const loadData = async () => {
    let normalizedStartDate = new Date(fromDate);
    normalizedStartDate.setHours(0);
    normalizedStartDate.setMinutes(0);
    normalizedStartDate.setSeconds(0);
    normalizedStartDate.setMilliseconds(0);

    let normalizedEndDate = new Date(toDate);
    normalizedEndDate.setHours(0);
    normalizedEndDate.setMinutes(0);
    normalizedEndDate.setSeconds(0);
    normalizedEndDate.setMilliseconds(0);

    normalizedEndDate = new Date(
      normalizedEndDate.getTime() -
      normalizedEndDate.getTimezoneOffset() * 60000,
    );
    normalizedStartDate = new Date(
      normalizedStartDate.getTime() -
      normalizedStartDate.getTimezoneOffset() * 60000,
    );

    const data = await callAPI({
      url: "/groups-by-user",
      params: {
        userId,
        fromDate: normalizedStartDate,
        toDate: normalizedEndDate,
      },
      preventCall: !userId,
    });

    setComposedData(data);
    checkAllLessonsToRecover();
  };

  useEffect(() => {
    if (userId) {
      loadData();
    }
  }, [userId, fromDate, toDate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
        <IonRefresherContent></IonRefresherContent>
      </IonRefresher>
      <h1
        style={{
          color: "#062a40",
          padding: "0 20px",
        }}
      >
        Registro lezioni
      </h1>
      <IonList>
        <IonItem>
          <IonLabel>Data Inizio</IonLabel>
          <IonDatetimeButton
            datetime="calendarFromDate"
            onClick={() => setShowFromDateModal(true)}
          ></IonDatetimeButton>
          <IonModal
            keepContentsMounted={true}
            onIonModalDidDismiss={() => setShowFromDateModal(false)}
            isOpen={showFromDateModal}
          >
            <IonDatetime
              presentation="date"
              id="calendarFromDate"
              value={fromDate.toISOString()}
              min="2025-03-01"
              onIonChange={(e) => {
                setShowFromDateModal(false);
                setFromDate(new Date(e.detail.value));
              }}
            ></IonDatetime>
          </IonModal>
        </IonItem>
        <IonItem>
          <IonLabel>Data Fine</IonLabel>
          <IonDatetimeButton
            datetime="calendarToDate"
            onClick={() => setShowToDateModal(true)}
          ></IonDatetimeButton>
          <IonModal
            keepContentsMounted={true}
            onIonModalDidDismiss={() => setShowToDateModal(false)}
            isOpen={showToDateModal}
          >
            <IonDatetime
              id="calendarToDate"
              presentation="date"
              value={toDate.toISOString()}
              onIonChange={(e) => {
                setShowToDateModal(false);
                setToDate(new Date(e.detail.value));
              }}
            ></IonDatetime>
          </IonModal>
        </IonItem>
        {lessonsToRecover >= 0 && (
          <IonItem style={{ display: "flex" }}>
            <IonLabel>Lezioni da recuperare</IonLabel>
            <IonLabel className="ion-text-end" style={{ marginLeft: "auto" }}>{lessonsToRecover}</IonLabel>
          </IonItem>
        )}
      </IonList>
      <div
        style={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        {filteredData && filteredData.length > 0 && (
          <div>
            {filteredData.map((item) => (
              <LessonCard
                key={item.id}
                data={item}
              />
            ))}
          </div>
        )}
      </div>
    </div >
  );
}

UserLessonsContent.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default UserLessonsContent;
